import React, { Component } from 'react';
import { toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import { getPaginationConfig } from '../../../components/pagination';
import { Table, Button, Modal, Popover } from 'antd';
import { QuestionCircleFilled, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import FormModal from './GroupFormModal';
const { confirm } = Modal;
@inject('indexManagementStore')
@observer
class SearchResult extends Component {
  state = {
    addModalVisible: false,
    record: null
  }
  componentDidMount() {
  }
  handleEdit = (record) => {
    const { indexManagementStore } = this.props;
    indexManagementStore.onGetIndexNameAction()
    indexManagementStore.onGetGroupAction(record.id).then(res => {
      this.setState({
        addModalVisible: true,
      })
    })
  }
  handleCancel = () => {
    this.setState({
      addModalVisible: false
    })
  }
  handleDel = (record) => {
    const { indexManagementStore } = this.props;
    confirm({
      title: 'Delete Data',
      icon: <QuestionCircleFilled />,
      content: 'Are you sure you want to delete it ?',
      okText: 'Delete',
      cancelText: 'Cancel',
      onOk() {
        indexManagementStore.onDeleteGroupAction(record.id);
      },
      onCancel() {
        console.log('Cancel');
      },
    })
    return false;
  }
  handlePageChange = (page, pageSize) => {
    const { indexManagementStore } = this.props;
    indexManagementStore.onChangePageNumGroupAction(page, pageSize);
  }
  getRowClassName = (record, index) => {
    let className = '';
    className = index % 2 === 0 ? 'oddRow' : 'evenRow';
    return className;
  }

  content = (index) => {
    const { indexManagementStore, } = this.props
    const { indexGroupSetList } = indexManagementStore
    return (
      <div>
        {
          indexGroupSetList[index].indexName.map((ele, i) => {
            return (
              <p key={i}>{ele}</p>
            )
          })
        }
      </div>
    );
  }

  render() {
    const { indexManagementStore, } = this.props
    const { pageNoGroup, pageSizeGroup, itemCountGroup, indexGroupSetList } = indexManagementStore
    const pagination = getPaginationConfig(pageNoGroup, pageSizeGroup, itemCountGroup, this.handlePageChange);
    return (
      <>
        <Table className='searchResult' dataSource={toJS(indexGroupSetList)} pagination={pagination} rowKey="id" rowClassName={this.getRowClassName} bordered>
          <Table.Column title='Index Set Name' dataIndex="groupName" key="groupName" />
          <Table.Column title='Index Name' dataIndex="indexName" key="indexName" render={(text, record, index) => {
            let _text = text.join()
            return (
              <Popover key={index} content={this.content(index)}>{_text}</Popover>
            )
          }} />
          <Table.Column width={150} align='center' title="Action" key="Action" render={(text, record) => (
            <>
              <Button onClick={() => this.handleEdit(record)} type='link' icon={<EditOutlined />} title='Edit' />
              <Button type='link' onClick={() => this.handleDel(record)} icon={<DeleteOutlined />} title='Delete' />
            </>
          )} />
        </Table>
        {this.state.addModalVisible ? <FormModal
          addModalVisible={this.state.addModalVisible}
          handleCancel={this.handleCancel}
          title='edit'
        /> : null}
      </>
    );
  }
}

export default SearchResult;
